import React from 'react';
import { Link } from 'react-router-dom';
import Buttons from './Buttons';
import Tables from './Tables';
import Tabs from './Tabs';
import Dropdowns from './Dropdowns';
import Radios from './Radios';
import Checkboxs from './Checkboxs';
import Forms from './Forms';
import Form4Columns from './Form4Columns';
import Form3Columns from './Form3Columns';
import Form2Columns from './Form2Columns';
import Popups from './Popups';
import Popovers from './Popovers';
import RightSidePanel from './RightSidePanel';
import './style.scss';

export default function Elements() {

  return (
    <React.Fragment>
      {/* Breadcrumb */}
      <div className={'breadcrumb'}>
        <div className={'breadcrumb-left'}>
          <div className={'breadcrumb-page-title'}>Elements</div>
        </div>
        <div className={'breadcrumb-right'}>
          <Link to="/" className={'breadcrumb-item'}>Home</Link>
          <span className={'breadcrumb-item active'}>Elements</span>
        </div>
      </div>

      <div className={'section'}>
        <div className={'section-heading has-page-title'}>
          <h4 className={'page-title'}>Buttons</h4>
        </div>
        <div className={'section-body'}>
          <Buttons />
        </div>
      </div>

      <div className={'section'}>
        <div className={'section-heading has-page-title'}>
          <h4 className={'page-title'}>Table - Datagrid</h4>
        </div>
        <div className={'section-body'}>
          <Tables />
        </div>
      </div>

      <div className={'section'}>
        <div className={'section-heading has-page-title'}>
          <h4 className={'page-title'}>Tabs</h4>
        </div>
        <div className={'section-body'}>
          <Tabs />
        </div>
      </div>

      <div className={'section'}>
        <div className={'section-heading has-page-title'}>
          <h4 className={'page-title'}>Dropdowns</h4>
        </div>
        <div className={'section-body'}>
          <Dropdowns />
        </div>
      </div>

      <div className={'section'}>
        <div className={'section-heading has-page-title'}>
          <h4 className={'page-title'}>Radios</h4>
        </div>
        <div className={'section-body'}>
          <Radios />
        </div>
      </div>

      <div className={'section'}>
        <div className={'section-heading has-page-title'}>
          <h4 className={'page-title'}>Checkboxs</h4>
        </div>
        <div className={'section-body'}>
          <Checkboxs />
        </div>
      </div>

      <div className={'section'}>
        <div className={'section-heading has-page-title'}>
          <h4 className={'page-title'}>Forms</h4>
        </div>
        <div className={'section-body'}>
          <Forms />
        </div>
      </div>

      <div className={'section'}>
        <div className={'section-heading has-page-title'}>
          <h4 className={'page-title'}>Form 4 Columns</h4>
        </div>
        <div className={'section-body'}>
          <Form4Columns />
        </div>
      </div>

      <div className={'section'}>
        <div className={'section-heading has-page-title'}>
          <h4 className={'page-title'}>Form 3 Columns</h4>
        </div>
        <div className={'section-body'}>
          <Form3Columns />
        </div>
      </div>

      <div className={'section'}>
        <div className={'section-heading has-page-title'}>
          <h4 className={'page-title'}>Form 2 Columns</h4>
        </div>
        <div className={'section-body'}>
          <Form2Columns />
        </div>
      </div>

      <div className={'section'}>
        <div className={'section-heading has-page-title'}>
          <h4 className={'page-title'}>Popups - Modal boxs</h4>
        </div>
        <div className={'section-body'}>
          <Popups />
        </div>
      </div>

      <div className={'section'}>
        <div className={'section-heading has-page-title'}>
          <h4 className={'page-title'}>Popovers</h4>
        </div>
        <div className={'section-body'}>
          <Popovers />
        </div>
      </div>

      <div className={'section'}>
        <div className={'section-heading has-page-title'}>
          <h4 className={'page-title'}>Right Sidebar</h4>
        </div>
        <div className={'section-body'}>
          <RightSidePanel />
        </div>
      </div>

    </React.Fragment>
)}
